import React, { useContext, useState } from 'react';
import axios from "axios";
import { Loading } from "../../components"
import { UserContext } from '../../contexts';

import './subscription.scss';

export function Subscription() {
  const [isLoadingPortal, setIsLoadingPortal] = useState(false);
  const { user } = useContext(UserContext);

  const tierName = user?.active_plan;

  const goToPortal = async () => {
    setIsLoadingPortal(true)

    const response = await axios.post(`/api/merchant/${user.id}/stripe-portal`, {
      return_url: `${window.RETAIL_CIRCLE_DOMAIN}/manage-account`
    });
    window.open(response.data.url, '_blank');
    setIsLoadingPortal(false);
  }

  return (
    <div className="subscription row">
      <div className="col-6 tier-name">
        {tierName}
      </div>
      <div className="col-6 manage">
        <button type="button" onClick={goToPortal}>
          {isLoadingPortal ? "Redirecting..." : "Manage"}
        </button>
      </div>
    </div>
  );
}
